import {StageService} from './stage.service';
import {Injectable} from '@angular/core';
import {ObjectCheckerService} from './object-checker.service';
import {WallCutService} from './wall/wall-cut.service';
import {RailingGenerationService} from './railing/services/railing-generation.service';

@Injectable()
export class DeleteObjectService {

  constructor(
    private stageSrvc: StageService,
    private objectCheckerSrvc: ObjectCheckerService,
    private wallCutSrvc: WallCutService,
    private railingGenerationService: RailingGenerationService
  ) {
  }

  delete(object) {

    if (this.objectCheckerSrvc.isFloor(object) && this.stageSrvc.getCompoundFloor() !== object) {
      const latestFloor = this.stageSrvc.getChildrenByPredicate(obj => obj.userData.customId === object.userData.customId)[0];
      const floorToDelete = object === latestFloor ? object : this.stageSrvc.getObjectById(latestFloor.id);
      floorToDelete.userData.edge.firstPoint.superstructureType = null;
      this.stageSrvc.remove(floorToDelete);
      this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());
      return;
    }

    if (this.objectCheckerSrvc.isWallEmbeddable(object)) {
      const parent = object.parent;
      this.stageSrvc.remove(object);
      this.wallCutSrvc.cutHoles(parent);
      return;
    }

    if (this.objectCheckerSrvc.isStairs(object)) {
      const firstPoint = object.userData.config.firstPoint;
      firstPoint.superstructureType = null;
      firstPoint.distance = null;
      firstPoint.superstructureId = null;
      firstPoint.floor = null;
      this.stageSrvc.remove(object);
      this.railingGenerationService.buildRailing(this.railingGenerationService.IsVisible());
    }

    this.stageSrvc.remove(object);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/delete-object.service.ts